import { Condition, LogicalOperator, Operation } from '@ydistri/api-sdk';
import { ROOT_CATEGORY_ID } from '../../components/global/_constants';
import { CalculationCategoryPairingRequest } from '../Calculations/apiCalculationsCategories';
import { SkuRedistributionPaneType } from './Redistribution/redistributionTypes';

export const SOURCE_SKU_ID_FILTER_FIELD = 'SourceSku/SkuId';
export const TARGET_SKU_ID_FILTER_FIELD = 'TargetSku/SkuId';

export const createSinglePickingPositionConditions = (
  sourceSkuId: number,
  targetSkuId: number,
): Condition[] => [
  { fieldName: SOURCE_SKU_ID_FILTER_FIELD, operation: Operation.Eq, value: sourceSkuId },
  { fieldName: TARGET_SKU_ID_FILTER_FIELD, operation: Operation.Eq, value: targetSkuId },
];

export const createSkuPairingRequest = (
  calculationId: number,
  sourceOrTarget: SkuRedistributionPaneType,
  skuId: number,
  skip?: number,
  top?: number,
): CalculationCategoryPairingRequest => ({
  calculationId,
  categoryId: ROOT_CATEGORY_ID,
  skip: skip ?? 0,
  top: top ?? 100,
  conditions: [
    {
      fieldName:
        sourceOrTarget === 'Source' ? SOURCE_SKU_ID_FILTER_FIELD : TARGET_SKU_ID_FILTER_FIELD,
      operation: Operation.Eq,
      value: skuId,
      logicalOperator: LogicalOperator.Or,
    },
  ],
});

export const createDefaultSkuPairingRequest = (
  calculationId: number,
  sourceOrTarget: SkuRedistributionPaneType,
  skuId: number,
): CalculationCategoryPairingRequest =>
  createSkuPairingRequest(calculationId, sourceOrTarget, skuId, 0, 100);
